
import React, { useRef, useState, useEffect } from 'react';
import chatbot_message_icon from '../../../assets/img/chatbot-message-icon.jpg'
import chatbot_logo_icon from '../../../assets/img/chat-bot-logo.svg'
import botImage from '../../../assets/img/bot-image.svg'
import './chatBot.scss'
const Chatbot = (props) => {
    let { className = '', getIsOpen = () => { } } = props
    const [messages, setMessages] = useState([
        {
            "sender": "You",
            "message": "hi",
            "type": "user"
        },
        {
            "sender": "AI",
            "message": "Hey there! What game are you playing today?",
            "type": "bot"
        }
    ]);
    const [userInput, setUserInput] = useState('');
    const [showChatbot, setShowChatBot] = useState(false);
    const [typingMessage, setTypingMessage] = useState('');
    const lastMessageRef = useRef(null);
    const [suggestions, setSuggestions] = useState(['Do you want to see your reports?', 'I am looking for something.', 'I want to start the game.']);

    const sendMessage = (suggestionMessage) => {
        const message = userInput?.trim() || suggestionMessage;
        console.log("message ::", message);
        if (message) {
            appendMessage('You', message, 'user');
            getBotResponse(message);
            setUserInput('');
        }
    };

    const appendMessage = (sender, message, type) => {
        const newMessage = { sender, message, type };
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        if (lastMessageRef.current) {
            lastMessageRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const responses = {
        'hello': 'Hi gamer! How can I assist you today?',
        'hi': 'Hey there! What game are you playing today?',
        'help': "Sure, I'm here to help. What do you need assistance with?",
        'thank you': "You're welcome! If you need anything else, just let me know.",
        'thanks': "You're welcome! If you need anything else, just let me know.",
        'goodbye': "Goodbye! Have a great gaming session!",
        'bye': "Goodbye! Have a great day!",
        'recommend a game': "Sure! Have you tried playing 'The Circuit Boards', 'The Parts Shop' and  'The Assembly Line'?",
        'best game of all time': "That's subjective, but many consider 'The Legend of Zelda: Ocarina of Time' as one of the best!",
        'how to improve gaming skills': "Practice regularly, watch tutorials, and learn from experienced players!",
        'what\'s your favorite game': "I don't play games, but I've heard a lot of great things about 'Minecraft'!",
        'latest game releases': "The latest game releases include 'Cyberpunk 2077' and 'Assassin's Creed Valhalla'.",
        'how to stream games': "To stream games, you need a good internet connection, a streaming platform like Twitch, and streaming software like OBS Studio.",
        'game development resources': "You can find great resources for game development on websites like Unity, Unreal Engine, and GameDev.net.",
        'game recommendations for kids': "Some great games for kids include 'Minecraft', 'Animal Crossing: New Horizons', and 'Super Mario Odyssey'.",
        'how to fix lag in games': "To fix lag, try lowering game settings, closing background applications, and ensuring your internet connection is stable.",
        'esports tournaments': "Some popular esports tournaments are 'The International' for Dota 2, and 'League of Legends World Championship'.",
        'how to become a pro gamer': "To become a pro gamer, focus on one game, join online communities, participate in tournaments, and practice consistently.",
        'popular game genres': "Popular game genres include action, adventure, role-playing, simulation, strategy, and sports.",
        'upcoming game releases': "Upcoming game releases include 'Horizon Forbidden West' and 'Elden Ring'.",
        'game walkthroughs': "You can find game walkthroughs on YouTube or websites like GameFAQs and IGN.",
        'how to build a gaming PC': "To build a gaming PC, you'll need a good CPU, GPU, RAM, motherboard, storage, and a power supply. There are many online guides to help you!",
        'top games in 2024': "Some top games in 2024 include 'Starfield', 'Final Fantasy XVI', and 'Hogwarts Legacy'.",
        'gaming tips for beginners': "Start with easier games, take breaks, join online communities, and watch gameplay videos to learn.",
        'best multiplayer games': "Some of the best multiplayer games are 'Fortnite', 'Apex Legends', and 'Among Us'.",
        'game updates': "For game updates, check the official website or forums of the game you're playing.",
        'how to join a gaming clan': "To join a gaming clan, look for recruitment posts on forums or social media, or ask in-game."
    };

    const suggestionResponses = {
        'hello': ['recommend a game', 'latest game releases', 'game development resources']
    }


    const simulateTyping = (response) => {
        setTypingMessage('');
        let index = 0;
        const interval = setInterval(() => {
            setTypingMessage(prev => prev + response.charAt(index));
            index++;
            if (index === response.length) {
                clearInterval(interval);
                setMessages(prevMessages => prevMessages.map(msg =>
                    msg.sender === 'AI' && msg.message === '' ? { ...msg, message: response } : msg
                ));
                setTypingMessage('');
            }
        }, 50); // Adjust the speed of typing effect here (50ms per character)
    };

    const getBotResponse = (message) => {
        let response = responses['default'] || "I don't understand. Can you rephrase?";
        for (const key in responses) {
            if (message.toLowerCase().includes(key)) {
                response = responses[key];
                break;
            }
        }

        setSuggestions([]);

        for (const key in suggestionResponses) {
            if (message.toLowerCase().includes(key)) {
                setSuggestions(suggestionResponses[key]);
                break;
            }
        }
        appendMessage('AI', '', 'bot');
        setTimeout(() => simulateTyping(response), 500);
    };

    const handleToggleChatbot = () => {
        getIsOpen(!showChatbot)
        setShowChatBot(prev => !prev);
    };

    const handleSuggestionClick = (suggestion) => {
        sendMessage(suggestion);
        setSuggestions([])
    };

    useEffect(() => {
        if (lastMessageRef.current) {
            lastMessageRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages, typingMessage]);

    return (
        // <main className="talwind-dashboard max-w-xs mx-auto pt-24 pb-20 flex flex-col gap-6 w-full transition-all duration-300 sm:max-w-[420px] md:max-w-[calc(100vw-80px)] md:pl-16">
        <div className={`${className}`}>
            <section id="chatbot" className={`flex flex-col gap-3 transition-transform duration-500 ease-in-out transform ${showChatbot ? 'scale-100 opacity-100 h-full' : 'scale-90 opacity-0 h-0'}`}>
                {showChatbot && <>
                    <div className="flex gap-2 items-center justify-between">
                        <div className="flex items-center w-full px-2 py-1">
                            <img src={chatbot_logo_icon} className="h-14" alt="Chatbot" />
                        </div>
                        <div className="pe-1 h-full">
                            <div
                                onClick={handleToggleChatbot}
                                className="cursor-pointer bg-white text-gray-400 px-1 py-0.5 rounded-full shadow border-gray-200 hover:shadow-gray-600 "
                            >
                                <i aria-hidden="true" className="close icon m-0 text-lg"></i>
                            </div>
                        </div>
                    </div>
                    <div className="chat-box bg-white shadow rounded-lg p-4 border rounded shadow h-full overflow-y-auto chatbot-scrollbar">
                        <div id="chat-log" className="space-y-2 overflow-y-auto py-1">
                            {messages.map((msg, index) => (
                                <div
                                    key={index}
                                    ref={index === (messages.length - 1) ? lastMessageRef : null}
                                    className={`flex ${msg.type === 'user' ? 'justify-end' : 'justify-start'} ${msg.type !== 'user' && typingMessage && (index === (messages.length - 1)) ? 'hidden' : ''} gap-3 my-4 text-gray-600 text-sm flex-1`}
                                >
                                    {msg.type !== 'user' && (
                                        <span className="relative flex shrink-0 overflow-hidden w-12 h-12">
                                            <div className=" h-12 w-12">
                                                <img src={botImage} alt='botImage' />
                                            </div>
                                        </span>
                                    )}
                                    <div className='flex flex-col gap-2'>
                                    <p
                                        className={`leading-relaxed px-4 py-2 max-w-xs text-base ${msg.type === 'user'
                                            ? 'bg-[#1b75bc] !text-white flex flex-col  max-w-[320px] leading-1.5 p-4  rounded-s-xl rounded-b-xl'
                                            : 'bg-slate-200 flex flex-col max-w-[320px] leading-1.5 p-4 border-gray-200 bg-gray-100 rounded-e-xl rounded-es-xl dark:bg-gray-700"'
                                            }`}
                                    >
                                        <span
                                            className={`block font-bold ${msg.type === 'user' ? 'text-white text-end' : 'text-gray-700'
                                                }`}
                                        >
                                            {msg.sender}
                                        </span>
                                        {msg.message}
                                    </p>
                                    {
                                        (msg.type !== 'user') && (index === (messages.length - 1)) && (
                                            <div className='flex flex-col gap-2 flex-wrap'>
                                                {suggestions.map((suggestion, index) => (
                                                    <button className='px-2 py-2 bg-white text-left w-fit text-gray-800 font-bold rounded-md border shadow border-gray-300' key={index} onClick={() => handleSuggestionClick(suggestion)}>{suggestion}</button>
                                                ))}
                                            </div>
                                        )
                                    }
                                    </div>

                                    {msg.type === 'user' && (
                                        <span className="relative flex shrink-0 overflow-hidden rounded-full w-12 h-12">
                                            <div className="rounded-full bg-gray-100 border">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth="1.5"
                                                    stroke="currentColor"
                                                    className="h-full w-full"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0m11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                                    />
                                                </svg>
                                            </div>
                                        </span>
                                    )}
                                </div>
                            ))}
                            {typingMessage && (
                                <div className="flex justify-start gap-3 my-4 text-gray-600 text-sm flex-1">
                                    <span className="relative flex shrink-0 w-12 h-12">
                                        <div className=" h-12 w-12">
                                            <img src={botImage} alt='botImage' />
                                        </div>
                                    </span>
                                    <p className="relative max-w-[80%] py-2 px-4 rounded-lg bg-slate-200 text-gray-800 shadow-md border border-gray-100 mb-2">
                                        <span className="block font-bold text-gray-700">AI</span>
                                        {typingMessage}
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                    {/* <div className="suggestions flex gap-2">
                        {suggestions.map((suggestion, index) => (
                            <button className='px-2 py-1.5 bg-white text-gray-800 font-bold rounded-lg border shadow border-gray-200' key={index} onClick={() => handleSuggestionClick(suggestion)}>{suggestion}</button>
                        ))}
                    </div> */}
                    <div className="mt-4 flex items-center gap-2">
                        <input
                            type="text"
                            id="user-input"
                            className="flex-grow p-2 border rounded-l bg-[#F5F8FE] border-gray-400 text-gray-700"
                            placeholder="Type your message"
                            value={userInput}
                            onChange={(e) => setUserInput(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
                            autoComplete='off'
                        />
                        <button onClick={() => sendMessage()} className="bg-blue-500 text-white p-1.5 rounded">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 26" stroke-width="1.5" stroke="currentColor" className="size-8">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5" />
                            </svg>
                        </button>
                    </div>
                </>}
            </section>
            <section id='chatbot-open-button' className={`flex flex-col gap-3 transition-transform duration-500 ease-in-out transform ${showChatbot ? 'scale-90 opacity-0 h-0' : 'scale-100 opacity-100'}`}>
                <div className='flex items-center justify-end'>
                    <div className='h-18 w-16 rounded-full overflow-hidden cursor-pointer' onClick={handleToggleChatbot}>
                        <img src={chatbot_message_icon} className='h-16 w-16 rounded-full scale-[1.4]' alt='chatbot_message_icon' />
                    </div>
                </div>
            </section>
        </div>
        // </main>
    );
};

export default Chatbot;
